import { makeAutoObservable } from "mobx";

export default class WholesalerStore {

  originOrderText: string = '';
  deliveryDrivers: any[] = [];
  deliveryVehicles: any[] = [];
  
  isScheduleDirty: boolean = false; // when today delivery page is dirty...

  setIsScheduleDirty(value: boolean) {
    this.isScheduleDirty = value;
  }

  constructor() {
    makeAutoObservable(this);
  }

  setOriginOrderText(values:string) {
    this.originOrderText = values;
  }

  setDeliveryDrivers(values:any[]) {
    this.deliveryDrivers = values;
  }

  setDeliveryVehicles(values:any[]) {
    this.deliveryVehicles = values;
  }
}